"use client";

import { createContext, useContext } from "react";

/* The site's name as the platform reports it — `GET /site`, resolved on the
   server by the root layout and handed down, so the first paint already has
   it. The API owns this value: there is no override in the content store, and
   anything on the site that names the operator reads it from here. */
export const SiteNameContext = createContext<string>("");

export const useSiteName = () => useContext(SiteNameContext);
